export default "__VITE_ASSET__CkAEKtZO__"